import { Info } from '@phosphor-icons/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { IJob } from 'jobs/types';
import { Variant } from 'theme/enums';

import { JobDetailsDrawer } from './JobDetailsDrawer';

interface IProps {
  job: IJob;
}

export const JobDetailsDrawerButton = ({ job }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  return (
    <>
      <Button
        text={t('buttonLabelJobDetails')}
        startDecorator={<Info />}
        variant={Variant.OUTLINED}
        onClick={() => setIsOpen(true)}
      />

      <JobDetailsDrawer isOpen={isOpen} onClose={() => setIsOpen(false)} job={job} />
    </>
  );
};
